<template>
    <div class="module">
        <helpinfo :helpData="helpData" />
        <envSelect @envId="envClick"></envSelect>
        <div class="module-container"
             style="margin-top:-17px;">
            <input ref="copyrelay"
                   v-model="id"
                   class="copy-el" />
            <rcTable ref="rcTable"
                     :tableAttr="tableAttr">
                <Button slot="tootipL"
                        @click="refresh">
                    <i class="icon-refresh-o-2"></i>
                </Button>
            </rcTable>
        </div>
        <bindfloatip ref="bindfloatip"
                     @refresh="refresh"></bindfloatip>
        <adjustBandwidth ref="adjustBandwidth"
                         @refresh="refresh"></adjustBandwidth>
    </div>
</template>
<script>
import helpinfo from '@c/basic/helpinfo'
import rcTable from '@c/basic/rcTable'
import envSelect from '@c/basic/env'
import API from '@/service/api.js'
import adjustBandwidth from './components/adjustbandwidth'
import bindfloatip from './components/bindfloatip'
export default {
    name: 'floatip',
    components: {
        helpinfo,
        rcTable,
        bindfloatip,
        adjustBandwidth,
        envSelect
    },
    data () {
        return {
            id: null,
            helpData: {
                modelName: this.$t('弹性IP'),
                showBack: false
            },
            status: { // 状态翻译
                ACTIVE: this.$t('运行中'),
                UNUSED: this.$t('未使用'),
                CREATE_FAILURE: this.$t('创建失败'),
                CREATING: this.$t('创建中'),
                DELETING: this.$t('释放中'),
                BANDING: this.$t('绑定中'),
                UNBANDING: this.$t('解绑中'),
                RESERVED: this.$t('预占用'),
                DELETED: this.$t('已删除')
            },
            internetChargeTypeObj: {
                PayByBandwidth: this.$t('按固定带宽计费'), // Aliyun
                PayByTraffic: this.$t('按流量计费'), // Aliyun
                'sta per': this.$t('静态BGP,独享带宽'), // HuaweiCloud
                'sta all': this.$t('静态BGP,共享带宽'), // HuaweiCloud
                'mov per': this.$t('动态BGP,独享带宽'), // HuaweiCloud
                'mov all': this.$t('动态BGP,共享带宽'), // HuaweiCloud
                'un per': this.$t('联通,独享带宽'), // HuaweiCloud
                'tel all': this.$t('电信,共享带宽')// HuaweiCloud
            },
            tableAttr: {
                source: {
                    type: 'get',
                    url: this.urlFormat(API.FLOATINGIPS, false),
                    params: {
                        envId: sessionStorage.getItem('resourcesEnvId') || null,
                        projectId: this.$store.state.user.currentUser.projectId === 'all' ? '' : this.$store.state.user.currentUser.projectId
                    }
                },
                isWebsoct: true,
                wsKey: 'id',
                searchColumns: [
                    {
                        key: 'ipLike',
                        title: this.$i18n.t('IP地址'),
                        searchDefaultValue: ''
                    }
                ],
                searchShow: true,
                tableSearchKey: 'allFloatingIpTable', // 当作查询保持的key存在
                searchDefaultValueList: [],
                isMultiSelect: false,
                columnsChooseShow: true,
                referenceVal: 1566,
                columns: [
                    {
                        title: this.$t('IP') + '/ID',
                        key: 'id',
                        sortable: false,
                        columnShow: true,
                        columnsChoosed: true,
                        disabledSearch: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 150,
                        render: (h, params) => {
                            return h('div', {
                                class: 'ellipsis  resource',
                                style: { position: 'relative' }
                            }, [
                                h(
                                    'div',
                                    {
                                        class: 'ellipsis',
                                        style: { width: '120px', paddingTop: '5px', height: '50px' }
                                    },
                                    [
                                        h('div',
                                            {
                                                class: 'ellipsis name',
                                                attrs: {
                                                    title: params.row.ip || '--'

                                                }
                                            },
                                            params.row.ip || '--'
                                        ),
                                        h(
                                            'div',
                                            {
                                                class: 'ellipsis',
                                                style: { width: '120px', color: '#666', paddingBottom: '5px' },
                                                attrs: {
                                                    title: params.row.uuid
                                                }
                                            },
                                            params.row.uuid
                                        ),
                                        h(
                                            'Tooltip',
                                            {
                                                class: 'rc-tips copyId',
                                                style: { position: 'absolute', left: '125px', top: '26px', width: '15px' },
                                                props: {
                                                    transfer: true,
                                                    placement: 'top',
                                                    theme: 'light',
                                                    content: this.$t('复制ID')
                                                }
                                            },
                                            [
                                                h('Icon', {
                                                    class: 'copy-icon',
                                                    style: { color: '#1f68b3', 'font-size': '14px' },
                                                    props: {
                                                        type: 'ios-browsers-outline'
                                                    },
                                                    on: {
                                                        click: () =>
                                                            this.copylink(
                                                                params.row.uuid
                                                            )
                                                    }
                                                })
                                            ]
                                        )
                                    ]
                                )
                            ])
                        }
                    },
                    // {
                    //     title: this.$t('IP地址'),
                    //     key: 'ip',
                    //     columnShow: true,
                    //     disabledSearch: true,
                    //     columnsChoosed: true,
                    //     className: 'ellipsis',
                    //     resizable: true,
                    //     width: 100,
                    //     render: (h, params) => {
                    //         return h('span', { attrs: { title: params.row.ip } }, params.row.ip)
                    //     }
                    // },
                    {
                        title: this.$t('云环境'),
                        key: 'cloudEnvType',
                        sortable: true,
                        disabledSearch: true,
                        columnShow: true,
                        columnsChoosed: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 200,
                        render: (h, params) => {
                            return h('p', { attrs: { title: params.row.cloudEnvName }, class: { 'rc-ellipsis': true } }, [
                                h('i', { class: this.envIcon(params.row.cloudEnvType), style: 'margin-right: 0' }),
                                h('span', { class: 'icon-text' }, !params.row.cloudEnvName ? this.$t('其他') : params.row.cloudEnvName)
                            ])
                        }
                    },

                    {
                        title: this.$t('状态'),
                        key: 'status',
                        columnShow: true,
                        columnsChoosed: true,
                        sortable: false,
                        className: 'ellipsis',
                        resizable: true,
                        width: 100,
                        filterMultiple: false,
                        filters: [
                            { value: 'ACTIVE', label: this.$t('运行中') },
                            { value: 'UNUSED', label: this.$t('未使用') },
                            { value: 'CREATE_FAILURE', label: this.$t('创建失败') },
                            { value: 'CREATING', label: this.$t('创建中') },
                            { value: 'DELETING', label: this.$t('释放中') },
                            { value: 'BANDING', label: this.$t('绑定中') },
                            { value: 'UNBANDING', label: this.$t('解绑中') },
                            { value: 'RESERVED', label: this.$t('预占用') },
                            { value: 'DELETED', label: this.$t('已删除') },
                            { value: 'CREATE_FAILURE', label: this.$t('创建失败') }

                        ],
                        render: (h, params) => {
                            let state = ''
                            let component = 'statusview'
                            if (params.row.status === 'CREATE_FAILURE') {
                                state = '创建失败'
                                component = 'syncpoptip'
                            } else {
                                state = this.status[params.row.status]
                            }
                            return h(component, {
                                props: component === 'syncpoptip' ? {
                                    value: this.$t(state),
                                    params: {
                                        resType: 'floating_ip',
                                        resSid: params.row.id
                                    }
                                }
                                    : {
                                        state: params.row.status.toLowerCase(),
                                        stateName: this.$t(state)
                                    }
                            })
                        }
                    },
                    {
                        title: this.$t('绑定资源'),
                        key: 'bindres',
                        columnShow: true,
                        disabledSearch: true,
                        columnsChoosed: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 140,
                        render: (h, params) => {
                            return h('div', [
                                h('a', { attrs: { title: params.row.instanceName }, on: { click: () => this.instanceFun(params.row) } }, params.row.instanceName),
                                h('p', { attrs: { title: params.row.instanceTypeName } }, params.row.instanceTypeName)
                            ])
                        }
                    },
                    {
                        title: this.$t('类型'),
                        key: 'internetChargeType',
                        columnShow: true,
                        disabledSearch: true,
                        columnsChoosed: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 140,
                        filterMultiple: false,
                        filters: [],
                        render: (h, params) =>
                            h('span', {
                                attrs: {
                                    title: this.internetChargeTypeObj[params.row.internetChargeType]
                                }
                            }, this.internetChargeTypeObj[params.row.internetChargeType])
                    },
                    {
                        title: this.$t('带宽') + '(Mbit/s)',
                        key: 'bandWidth',
                        columnShow: true,
                        disabledSearch: true,
                        columnsChoosed: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 100,
                        render: (h, params) => {
                            // const txt = ['HuaweiCloud', 'Qcloud', 'Aliyun'].includes(params.row.envType) ? ('(' + params.row.chargeType !== 'PrePaid' ? this.$t('按带宽计费') : this.$t('按月计费') + ')') : ''
                            return h('div', [
                                h('span', {
                                    attrs: { title: params.row.bandWidth }
                                }, params.row.bandWidth
                                )
                            ])
                        }
                    },
                    {
                        title: this.$t('计费类型'),
                        key: 'billingType',
                        columnShow: true,
                        disabledSearch: true,
                        columnsChoosed: true,
                        className: 'ellipsis',
                        resizable: true,
                        width: 120,
                        align: 'center',
                        render: (h, params) => {
                            const txt = params.row.chargeType === 'PrePaid' ? this.$t('包年包月') : this.$t('按量计费')
                            const arr = [
                                h('p', {
                                    attrs: { title: txt }
                                }, txt
                                )
                            ]
                            if (params.row.chargeType === 'PrePaid' && params.row.countdown && params.row.countdown !== null) {
                                let txtDay = ''
                                if (params.row.countdown >= 0 && this.$newTimeComparison(params.row.endTime)) {
                                    txtDay = params.row.countdown + this.$t('天后到期')
                                } else {
                                    txtDay = this.$t('已过期') + Math.abs(params.row.countdown) + this.$t('天')
                                }
                                arr.push(
                                    h('div', { style: { display: 'inline-block' } },
                                        [
                                            h('Tooltip', {
                                                props: { transfer: true, placement: 'right', theme: 'light' }
                                            }, [
                                                h('p', { class: 'txt-border' }, txtDay),
                                                h('div', { slot: 'content' }, [
                                                    h('p', this.$t('开始时间') + '：' + params.row.startTime || '--'),
                                                    h('p', this.$t('结束时间') + '：' + params.row.endTime || '--')
                                                ])]
                                            )
                                        ])
                                )
                            }
                            return h('div', arr)
                        }
                    },
                    {
                        title: this.$t('所属项目'),
                        key: 'orgName',
                        columnShow: true,
                        disabledSearch: true,
                        columnsChoosed: true,
                        className: 'ellipsis',
                        resizable: true,
                        minWidth: 100,
                        render: (h, params) => h('span', { attrs: { title: params.row.orgName } }, params.row.orgName)
                    },
                    // {
                    //     title: this.$t('私有IP'),
                    //     key: 'fixedIp',
                    //     columnShow: true,
                    //     disabledSearch: true,
                    //     columnsChoosed: true,
                    //     className: 'ellipsis',
                    //     resizable: true,
                    //     width: 90,
                    //     render: (h, params) => h('span', { attrs: { title: params.row.fixedIp } }, params.row.fixedIp)
                    // },

                    // {
                    //     title: this.$t('公网IP池'),
                    //     key: 'pool',
                    //     columnShow: true,
                    //     columnsChoosed: true,
                    //     sortable: false,
                    //     className: 'ellipsis',
                    //     resizable: true,
                    //     wiminWidthth: 100,
                    //     filterMultiple: false,
                    //     render: (h, params) => h('span', { attrs: { title: params.row.pool } }, params.row.pool)
                    // },
                    {
                        title: this.$t('操作'),
                        width: 240,
                        fixed: 'right',
                        render: (h, params) => {
                            const status = ['CREATING', 'DELETING', 'BANDING', 'UNBANDING'].includes(params.row.status)
                            return h('div', { class: 'tbl-btn-div' }, [
                                h('a', { class: { disabled: params.row.status === 'CREATE_FAILURE' || status || !this.hasPermission('CB090203') || !this.checkBtnStatus('binding', params.row) }, on: { click: () => params.row.status !== 'CREATE_FAILURE' && this.hasPermission('CB090203') && !status && this.checkBtnStatus('binding', params.row) && this.binding(params.row) } }, this.$t('绑定主机')), // 创建中，删除中不能绑定主机
                                h('a', { class: { disabled: params.row.status === 'CREATE_FAILURE' || status || !this.hasPermission('CB090204') || !this.checkBtnStatus('untied', params.row) }, on: { click: () => params.row.status !== 'CREATE_FAILURE' && this.hasPermission('CB090204') && !status && this.checkBtnStatus('untied', params.row) && this.unbinding(params.row) } }, this.$t('解绑主机')), // 创建中，删除中不能解绑主机
                                h('a', { class: { disabled: params.row.status === 'CREATE_FAILURE' || status || !this.hasPermission('CB090205') }, on: { click: () => params.row.status !== 'CREATE_FAILURE' && this.hasPermission('CB090205') && !status && this.resourceChangeFun(params.row) } }, this.$t('变更配置')), // 创建中，删除中不能资源变更
                                h('a', { class: { disabled: status || !this.hasPermission('CB090202') }, on: { click: () => this.hasPermission('CB090202') && !status && (params.row.chargeType === 'PrePaid' ? this.unsubscribeFun(params.row) : this.release(params.row)) } }, params.row.chargeType === 'PrePaid' ? this.$t('退订') : this.$t('释放'))// 运行中，创建中，删除中不能退订与释放
                            ])
                        }
                    }
                ]
            },
            envList: [],
            envData: null,
            isCreateModal: false, // 是否选中云环境
            isSelectedFloatIp: false // 是否选中floatingIp
        }
    },
    computed: {
        language () {
            return this.$store.state.app.appConfig.language
        }
    },
    methods: {
        instanceFun (row) {
            switch (row.instanceType) {
                case 'RES-HOST':
                    this.$router.push({
                        path: '/mgt/cloudhost',
                        query: { hostName: row.instanceName }
                    })
                    break
            }
        },
        // 变更规格
        resourceChangeFun (row) {
            this.$router.push({
                path: '/mgt/resourcechange',
                query: { id: row.id, type: 'floatip', envType: row.cloudEnvType, link: '/mgt/floatip' }
            })
        },
        // 退订
        unsubscribeFun (row) {
            this.$router.push({
                path: '/mgt/unsubscribe',
                query: { id: row.id, link: '/mgt/floatip' }
            })
        },
        // 云环境过滤
        envClick (data) {
            this.tableAttr.source.params.envId = data
            this.$refs.rcTable && this.$refs.rcTable.refreshTable()
        },
        refresh () { // 刷新
            this.isSelectedFloatIp = false
            this.$refs.rcTable.refreshTable()
        },
        checkBtnStatus (type, rowData) { // 按钮控制逻辑
            // 调整带宽，云环境：Aliyun，状态：['ACTIVE', 'UNUSED']，权限：'MD1004'
            // 解绑，云环境：除了腾讯云、WAS，状态：['ACTIVE']，资源类型：['RES-SLB', 'RES-HOST']，权限：'MD1006'
            // 绑定，云环境：除了腾讯云、WAS，状态：['UNUSED']，权限：'MD1005'
            // 释放，云环境：除了腾讯云、WAS，状态：['UNUSED']，权限：'MD1003'
            switch (type) {
                case 'binding': // 绑定
                    if (!['Qcloud', 'Aws'].includes(rowData.cloudEnvType) &&
                        ['UNUSED'].includes(rowData.status)) {
                        return true
                    }
                    return false
                case 'untied': // 解绑
                    if (!['Qcloud', 'Aws'].includes(rowData.cloudEnvType) &&
                        ['ACTIVE'].includes(rowData.status) &&
                        ['RES-SLB', 'RES-HOST'].includes(rowData.instanceType)) {
                        return true
                    }
                    return false
                case 'release':
                    if (!['Qcloud', 'Aws'].includes(rowData.cloudEnvType) &&
                        ['UNUSED'].includes(rowData.status)) {
                        return true
                    }
                    return false
                default:
                    return false
            }
        },
        websoctRefesh () {
            const refresh = this.$refs.rcTable.refreshTable
            this.instanceWs = this.$websocket('/topic/floating_ip', (result) => {
                refresh(null, null, result.body ? parseInt(result.body) : '')
            })
        },
        binding (obj) {
            // 绑定主机
            // if (!this.checkBtnStatus('binding', obj)) return
            this.isSelectedFloatIp = true
            this.$refs.bindfloatip.open(obj)
        },
        unbinding (obj) {
            // 解除绑定
            // if (!this.checkBtnStatus('untied', obj)) return
            this.$Modal.confirm({
                title: this.$t('解除绑定'),
                content: this.$t('您已经选择了') + `:${obj.ip}<div>` + this.$t('请确认您的选择。解绑操作可能会断开已绑定资源的网络') + '</div>',
                onOk: () => {
                    this.axios.put(this.urlFormat(API.FLOATINGIPS_DETACH, false), {
                        id: obj.id
                    }).then(res => {
                        this.refresh()
                    })
                }
            })
        },
        release (obj) {
            // // 释放弹性IP
            // if (!this.checkBtnStatus('release', obj)) return
            this.$Modal.confirm({
                title: this.$t('释放'),
                content: this.$t('您确认要释放该弹性IP吗？'),
                onOk: () => {
                    this.axios.delete(this.urlFormat(API.DELETE_SERVICE_UNSUBSCRIBE_ID, false, [obj.id])).then(res => {
                        this.refresh()
                    })
                }
            })
        },
        // 复制剪切板
        copylink (id) {
            this.id = id
            this.$nextTick(() => {
                const copyrelay = this.$refs.copyrelay
                copyrelay.select()
                document.execCommand('Copy')
                this.$Message.success(this.$t('ID复制成功'))
            })
        }
    }
}
</script>
<style lang="less" scoped>
.copy-el {
    opacity: 0;
    height: 1px;
    overflow: hidden;
    margin: 0;
    padding: 0;
}
</style>
<style lang="less">
.newRcTable .rcTable-content .ellipsis > div.copyId {
    opacity: 0;
}
.newRcTable .rcTable-content .ellipsis > div {
    .copyId {
        opacity: 0;
    }
}
.newRcTable .rcTable-content .ellipsis > div:hover {
    .copyId {
        opacity: 1;
    }
}
.newRcTable .rcTable-content .ellipsis > div {
    .name {
        line-height: 22px;
    }
    .copyId {
        line-height: 22px;
    }
}
</style>
